import React from 'react'
import { connect } from 'formik'
import classnames from 'classnames/bind'

// Components
import InputField from './components/InputField'
import CheckboxField from './components/CheckboxField'
import RadioField from './components/RadioField'
import VirtualizedSelectField from './components/VirtualizedSelectField'
import DatepickerField from './components/DatepickerField'
import TextareaField from './components/TextareaField'

// Style
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

function Form(props: any) {
  const { className, forwardRef, formik, ...restProps } = props

  return (
    <form
      className={cx('form', className)}
      ref={forwardRef}
      onReset={formik.handleReset}
      onSubmit={formik.handleSubmit}
      autoComplete='off'
      {...restProps}
    />
  )
}

const ConnectedForm = connect(Form)
const ConnectedFormWithRef: any = React.forwardRef((props, ref) => <ConnectedForm {...props} forwardRef={ref} />)

ConnectedFormWithRef.InputField = InputField
ConnectedFormWithRef.CheckboxField = CheckboxField
ConnectedFormWithRef.RadioField = RadioField
ConnectedFormWithRef.VirtualizedSelectField = VirtualizedSelectField
ConnectedFormWithRef.DatepickerField = DatepickerField
ConnectedFormWithRef.TextareaField = TextareaField

export default ConnectedFormWithRef
